import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "theme"];
import { ThemeProvider } from 'styled-components';
import cuiTheme from "../styles/theme";
import { jsx as _jsx } from "react/jsx-runtime";
var Layout = function Layout(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    layoutProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ThemeProvider, _objectSpread(_objectSpread({
    theme: theme || cuiTheme
  }, layoutProps), {}, {
    children: children
  }));
};
export default Layout;